import _jsx from "@babel/runtime/helpers/jsx";
var _InfoIcon;
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import clsx from 'clsx';
import { Button, DisclaimerText, InfoIcon, SubHeading, Table } from 'reaxl';
import EmailContext from '../EmailContext';
const renderTableRow = (content, isNdsCalc) => {
  const {
    label,
    value,
    isTotalValue
  } = content;
  const labelClassName = clsx({
    'margin-right-5': !isNdsCalc,
    'margin-top-3': isTotalValue
  }, 'pull-left');
  const valueClassName = clsx({
    'text-size-500 margin-top-3': isTotalValue
  }, 'text-bold pull-right');
  if (label === 'Taxes & Fees') {
    return /*#__PURE__*/_jsx("tr", {}, label, /*#__PURE__*/_jsx("td", {
      className: labelClassName
    }, void 0, label, "\xA0", _InfoIcon || (_InfoIcon = /*#__PURE__*/_jsx(InfoIcon, {
      placement: "top",
      infoText: "Usually includes sales tax, DMV fees, any lender fees for financing, plus dealer-related fees for doc and prep",
      id: "taxes-and-fees-info",
      className: "text-size-300"
    }))), /*#__PURE__*/_jsx("td", {
      className: valueClassName
    }, void 0, value));
  }
  return (value !== '$0' || value === '$0' && label === 'Estimated Cash Out of Pocket') && /*#__PURE__*/_jsx("tr", {}, label, /*#__PURE__*/_jsx("td", {
    className: labelClassName
  }, void 0, label), /*#__PURE__*/_jsx("td", {
    className: valueClassName
  }, void 0, value));
};
function WalletSnapshot(_ref) {
  let {
    action = {},
    contents = [],
    tableClassName,
    title,
    disclaimer
  } = _ref;
  const {
    uiContext
  } = useContext(EmailContext);
  if (!contents.length) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!Object.keys(action).length && /*#__PURE__*/_jsx(Button, {
    bsStyle: "text",
    className: "pull-right text-size-300",
    onClick: action.onClick
  }, void 0, action.label), /*#__PURE__*/_jsx(SubHeading, {
    size: 400
  }, void 0, title), !!disclaimer && /*#__PURE__*/_jsx(DisclaimerText, {
    weight: "normal"
  }, void 0, disclaimer), /*#__PURE__*/_jsx(Table, {
    className: clsx(tableClassName, 'margin-top-2 table-unstyled')
  }, void 0, /*#__PURE__*/_jsx("tbody", {}, void 0, contents.map(content => renderTableRow(content, uiContext === 'calculator')))));
}
export default WalletSnapshot;